
export class UrlHelper {


    public static serializeParams(data: any) {
        if (!data) return null;
        const json = JSON.stringify(data);
        return btoa(json);
    }

    public static deSerializeParams<T>(data: string): T {
        if (!data) return null;
        const json = atob(data);
        return JSON.parse(json) as T;
    }
}
